import React, { useEffect, useState } from "react";
import saveAs from "file-saver";
import axios from 'axios'; // npm i axios
import Navbar from '../NavbarSondagem/navbarSondagem';
import Conexao from '../../Config/conexao';
import ListaDinamicaAmostraDeformada from '../Amostragem/ListaDinamicaAmostraDeformada';
import { excel } from "react-export-table-to-excel/lib/lib";
import { TryRounded } from "@mui/icons-material";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import moment from 'moment'
import VariavelGlobal from '../../Config/Variavelglobal'




function AmostraDeformada(props) {

    const [furo, setFuro] = useState("")
    const [clientes, setClientes] = useState([])

    const [cliente1, setCliente1] = useState("")
    const [dataa, setDataa] = useState(Date)
    const [estrutura, setEstrutura] = useState("")
    const [localizacao, setLocalizacao] = useState("")
    const [profundidadeInicial, setProfundidadeInicial] = useState("")
    const [profundidadeFinal, setProfundidadeFinal] = useState("")
    const [coordenadaX, setCoordenadaX] = useState("")
    const [coordenadaY, setCoordenadaY] = useState("")
    const [cota, setCota] = useState("")
    const [amostraDeformada, setAmostraDeformada] = useState("")
    const [observacao, setObservacao] = useState("")



    const [profundidade, setProfundidade] = useState("")
    const [descricaoamostrado, setDescricaoamostrado] = useState("")




    const [confirmacao, setConfirmacao] = useState(false);
    const [confirmacaoId, setConfirmacaoId] = useState('');


    const [habilitar, setHabilitar] = useState(true)
    const [bnthabilitar, setBnthabilitar] = useState("true")
    const [setorLogado, setSetorLogado] = useState();

    const [show, setShow] = useState(false);
    function handleClose() { setShow(false) }
    const handleShow = () => setShow(true);

    function confirmDeleteUser(id) {
        setConfirmacaoId(id);
        setConfirmacao(true);
        // alert('Excluir o item:'+ id)
    }

    function confirmEdite(id, Topo, Base) {
        setConfirmacaoId(id);
        setProfundidade(Topo)
        setDescricaoamostrado(Base)
        handleShow()
    }

    function LimpacampoADD() {
        setConfirmacaoId(0);
        setProfundidade("");
        setDescricaoamostrado("");
        handleShow()

        // alert('Excluir o item:'+ id)
    }

    function carregaUser() { setSetorLogado(localStorage.usuario) };
    useEffect(() => { carregaUser() }, []);

    async function getNivel() {
        const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
        if (res.data.success === false) {
            //  setLoading(false)
            //  falha();  
        } else {

            if (res.data.nivel === "Gerente") {
                setHabilitar(false)
                setBnthabilitar(false)
                VariavelGlobal.ButtonEnable = false
                console.log("Nivel_Dentro  " + res.data.nivel);
                console.log("Usuario  " + setorLogado);
            } else {
                if (res.data.nivel === "Supervisor") {
                    setHabilitar(false)
                    setBnthabilitar(false)
                    VariavelGlobal.ButtonEnable = false
                } else {
                    setHabilitar(true)
                    setBnthabilitar(true)
                    VariavelGlobal.ButtonEnable = true
                }
            }

        }
    };

    async function BuscarIndeformadaFuro() {
        console.log('IndeformadaTUBO', furo)
        const res = await axios.get(Conexao.api + 'ListaAmostraDeformada.php?furo=' + furo);


        if (res.data.success === true) {


            setCliente1(res.data.result[0].cliente1)
            setDataa(res.data.result[0].dataa)
            setEstrutura(res.data.result[0].estrutura)
            setLocalizacao(res.data.result[0].localizacao)

            setCoordenadaX(res.data.result[0].coordenadaX)
            setCoordenadaY(res.data.result[0].coordenadaY)
            setCota(res.data.result[0].cota)
            setProfundidadeInicial(res.data.result[0].profundidadeInicial)
            setProfundidadeFinal(res.data.result[0].profundidadeFinal)
            setAmostraDeformada(res.data.result[0].amostraDeformada)
            setObservacao(res.data.result[0].observacao)

            setHabilitar(false)
            setBnthabilitar(false)
            VariavelGlobal.ButtonEnable = false
            getNivel()

        } else {

            VariavelGlobal.ButtonEnable = true
            LIMPAR()
            setHabilitar(true)
            setBnthabilitar(true)

            alert('INDERFORMADA BLOCO NÃO REALIZADO')
        }
        console.log('retornobusca INDERFORMADA', res.data.result)

        BuscarLista()


    };


    function confirmDeleteUser(id) {
        setConfirmacaoId(id);
        setConfirmacao(true);

        // alert('Excluir o item:'+ id)
    }
    async function deleteUser(confirmacaoId) {

        const res = await axios.get(Conexao.api + 'ExcluirListaDinamicaAmostraDeformada.php?id=' + confirmacaoId);
        if (res.data.success === true) {
            setConfirmacao(false);
            BuscarLista()
        }
    }

    async function SalvarListaD(id) {
        const obj = {
            furo, confirmacaoId, profundidade, descricaoamostrado
        };

        const res = await axios.post(Conexao.api + 'SalvarDinamica_AmostraDeformada.php', obj);

        console.log('lista Dinamica', obj)

        if (res.data.success === true) {
            setShow(false);
            BuscarLista()
        }

    };
    async function BuscarLista() {

        const res = await axios.get(Conexao.api + 'ListaDinamica_AmostraDeformada.php?furo=' + furo);
        if (res.data.success) {
            setClientes(res.data.result)
        } else {
            setClientes([])
            alert('NÃO REALIZADO')
        }

        console.log('Lista1  ' + res.data.success)

    };

    async function SalvarIndeformadaBloco() {
        const obj = {
            furo, cliente1, dataa, estrutura, localizacao, profundidadeInicial, profundidadeFinal, coordenadaX, coordenadaY, cota, amostraDeformada, observacao
        };

        const res = await axios.post(Conexao.api + 'SalvarAmostraDeformada.php', obj);

        console.log('SalvarLista', obj)

        if (res.data.success === true) {
            alert('Atualizado com Sucesso!')
        }
    };

    function LIMPAR() {

        setCliente1("")
        setDataa("")
        setEstrutura("")
        setLocalizacao("")
        setCoordenadaX("")
        setCoordenadaY("")
        setCota("")
        setProfundidadeInicial("")
        setProfundidadeFinal("")
        setAmostraDeformada("")
    }

    return (<div>
        <Navbar />
        <div className='titulolaboratorio container-fluid'>
            <h1 className='texttitulo'>COLETA DE AMOSTRA DE TRADO / DEFORMADA</h1>
        </div>

        <br />
        <br />

        <body class="container text-center ">

            <div class="container text-center ">
                <div class="row d-flex align-items-end justify-content-center p-2">

                    <div class="col-md-3 md-0">

                        <h6>IDENTIFICÃO DO FURO:</h6>
                        <input name='furo' id='furo' className='form-control text-center' onChange={(e) => setFuro(e.target.value)} ></input>

                        <div class="col-4">
                            <div className="btn btn-outline-success-center " type="submit"><button onClick={(e) => BuscarIndeformadaFuro(e)} class="btnlogin me-md-2" > Buscar</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </body>
        <br />
        <form className="container-fluid ">
            <br />
            <br />

            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">

                        <div class="col">
                            <h7>CLIENTES:</h7>
                            <input name='cliente1' id='cliente1' className='form-control text-center colorInput ' disabled={habilitar} value={cliente1} onChange={(e) => setCliente1(e.target.value)} ></input>
                        </div>

                    </div>
                </div>
            </body>
            <br />
            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">

                        <div class="col">
                            <h7>LOCAL:</h7>
                            <input name='localizacao' id='localizacao' className='form-control text-center colorInput ' disabled={habilitar} value={localizacao} onChange={(e) => setLocalizacao(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>ESTRUTURA:</h7>
                            <input name='estrutura:' id='estrutura' className='form-control text-center colorInput ' disabled={habilitar} value={estrutura} onChange={(e) => setEstrutura(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>DATA EXECUÇÃO:</h7>
                            <input name='dataa' id='dataa' type='date' className='form-control text-center colorInput ' disabled={habilitar} format='DD/MM/YYYY' value={dataa} onChange={(e) => setDataa(e.target.value)} ></input>
                        </div>

                    </div>
                </div>
            </body>

            <br />
            <br />

            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">


                        <div class="col">
                            <h7>PROFUNDIDADE INICIAL:(m):</h7>
                            <input name='profundidadeInicial' id='profundidadeInicial' className='form-control text-center colorInput ' disabled={habilitar} value={profundidadeInicial} onChange={(e) => setProfundidadeInicial(e.target.value)} ></input>
                        </div>



                        <div class="col">
                            <h7>PROFUNDIDADE FINAL:(m):</h7>
                            <input name='profundidadeFinal' id='profundidadeFinal' className='form-control text-center colorInput ' disabled={habilitar} value={profundidadeFinal} onChange={(e) => setProfundidadeFinal(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>AMOSTRA DEFORMADA:(Kg):</h7>
                            <input name='amostraDeformada' id='amostraDeformada' className='form-control text-center colorInput ' disabled={habilitar} value={amostraDeformada} onChange={(e) => setAmostraDeformada(e.target.value)} ></input>
                        </div>


                    </div>
                </div>
            </body>

            <br />
            <br />

            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">


                        <div class="col">
                            <h7>COORDENADA X (cm):</h7>
                            <input name='coordenadaX' id='coordenadaX' className='form-control text-center colorInput ' disabled={habilitar} value={coordenadaX} onChange={(e) => setCoordenadaX(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>COORDENADA Y (cm):</h7>
                            <input name='coordenadaY' id='coordenadaY' className='form-control text-center colorInput ' disabled={habilitar} value={coordenadaY} onChange={(e) => setCoordenadaY(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>COTA(cm):</h7>
                            <input name='cota' id='cota' className='form-control text-center colorInput ' disabled={habilitar} value={cota} onChange={(e) => setCota(e.target.value)} ></input>
                        </div>

                    </div>
                </div>
            </body>



            <br />
            <br />
            <br />
        </form>

        <div class="container text-center">
            <div class="row align-items-start">



                <ListaDinamicaAmostraDeformada arrayClientes={clientes} clickDelete={confirmDeleteUser} editar={confirmEdite} />
                <div className="btn btn-outline-success-center " type="submit">
                    <button onClick={LimpacampoADD} class="btnlogin  me-md-2  " > Adicionar </button>

                </div>
                {
                    confirmacao ? <SweetAlert
                        warning
                        showCancel
                        showCloseButton
                        confirmBtnText="Sim"
                        confirmBtnBsStyle="danger"
                        cancelBtnText="Não"
                        cancelBtnBsStyle="light"
                        title="Exclusão"
                        onConfirm={() => deleteUser(confirmacaoId)}
                        onCancel={() => setConfirmacao(false)}
                        reverseButtons={false}
                    >
                        Deseja excluir o Item selecionado?
                    </SweetAlert> : null}

                <Modal show={show} onHide={handleClose}  >

                    <Modal.Header closeButton>
                        <Modal.Title>COLETA DE AMOSTRA INDEFORMADA:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                        <Form>

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>ID SELECIONADO PARA MODIFICAÇÃO:</Form.Label>
                                <Form.Control
                                    type="text" disabled={true}
                                    onChange={(e) => { setConfirmacaoId(e.target.value) }}
                                    value={confirmacaoId}


                                />
                            </Form.Group>

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>PROFUNDIDADE:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setProfundidade(e.target.value) }}
                                    value={profundidade}

                                />
                            </Form.Group>

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Descrição tátil-visual do material amostrado:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setDescricaoamostrado(e.target.value) }}
                                    value={descricaoamostrado}
                                />
                            </Form.Group>


                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>Fechar</Button>
                        <Button variant="primary" onClick={(e) => (SalvarListaD(e))}>Salvar </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>

        <br />
        <br />





        <body class="container text-center ">

            <div class="container text-center ">
                <div class="row d-flex align-items-end justify-content-center p-2">

                    <div className="  col-12    ">
                        <h5 className="  label  " >OBSERVAÇÕES</h5>
                        <textarea cols={100} rows={6} className='form-control w-200 colorInput2 resize' name='observacoes' id='observacoes' disabled={habilitar} value={observacao} onChange={(e) => setObservacao(e.target.value)}  ></textarea>
                    </div>


                </div>
            </div>

        </body>

        <br />
        <br />
        <div class="row d-flex align-items-end justify-content-end ">
            <div class="col-4">
                <div className="btn btn-outline-success-center " type="submit">
                    <button onClick={(e) => (SalvarIndeformadaBloco(e))} class="btnlogin  me-md-2  " Button > Salvar </button>
                </div>
            </div>
        </div>

    </div>
    )
}
export default AmostraDeformada;